module.exports = __webpack_public_path__ + "img/logical-group.708b2985.png";